import angular from "angular";
import { moduleName as recordsModule } from "../../../records";
import { configureLookupManagement } from "../../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "./lookupManagement";
import { contactBookTypeConfig } from "./lookupManagement/contactBookType";
import { contactBookConfig } from "./contactBook";
export const vsModuleName = "ContactBookSharedConfigModule";

const module = angular
  .module(vsModuleName, [recordsModule])
  .config(contactBookConfig)
  .config(contactBookTypeConfig);

configureLookupManagement(module, {
  baseStateSref: "main.contactBook.lookups",
  lookupManagementServiceName: vsLookupManagementServiceName,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  defaultModifyPermission: "contactBookLookupModify",
});
